// extracted by mini-css-extract-plugin
module.exports = {"play":"hero-video-module--play--30kSW","logo":"hero-video-module--logo--qVNfd"};